import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import Modal from '@paradigm/design-system/src/components/Modal/Modal';
import CloseIcon from '@paradigm/design-system/src/assets/CloseIcon';
import { blueMana, firefly_2 } from '@paradigm/design-system/src/colors';
import useLocalStorage from '#/hooks/local-storage';
import btcOptionsScreenshot from '#/assets/btc-options-screenshot.png';
import { PARADEX_OPTIONS_ROUTE } from '#/routes';

const DISMISS_KEY = 'btc-options-promo-dismiss';

export default function BtcOptionsPromoModal() {
  const [dismissed, setDismissed] = useLocalStorage(DISMISS_KEY, false);
  const history = useHistory();

  if (dismissed) return null;
  const handleClose = () => setDismissed(true);

  const handleTradeNow = () => {
    handleClose();
    history.push(PARADEX_OPTIONS_ROUTE);
  };

  return (
    <StyledModal isOpen toggle={handleClose} width={500} fade={false}>
      <Header>
        <TitleGroup>
          <ModalTitle>BTC Options Now Live on Paradex</ModalTitle>
          <Subtitle>Public Beta</Subtitle>
        </TitleGroup>
        <StyledCloseIcon width={15} height={15} onClick={handleClose} />
      </Header>
      <Body>
        <Screenshot src={btcOptionsScreenshot} alt="BTC Options on Paradex" />
        <Footer>
          <TradeButton onClick={handleTradeNow}>Trade Now</TradeButton>
        </Footer>
      </Body>
    </StyledModal>
  );
}

const StyledModal = styled(Modal)`
  .modal-content {
    background-color: ${firefly_2} !important;
    box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.3);
    padding-top: 32px;
    padding-bottom: 32px;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 24px;
  margin-bottom: 16px;
`;

const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

const ModalTitle = styled.div`
  font-size: 20px;
  font-weight: 500;
  color: #fff;
`;

const Subtitle = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: ${blueMana};
  margin-top: 2px;
`;

const StyledCloseIcon = styled(CloseIcon)`
  color: ${blueMana};
  cursor: pointer;
  margin-top: 8px;
  flex-shrink: 0;
`;

const Body = styled.div`
  padding: 0 24px;
`;

const Screenshot = styled.img`
  width: 100%;
  border-radius: 8px;
  margin-bottom: 24px;
`;

const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const TradeButton = styled.button`
  border: none;
  background: ${blueMana};
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 28px;
  border-radius: 20px;
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.15s;

  &:hover {
    opacity: 0.9;
    text-decoration: none;
    color: #fff;
  }
`;
